const cambiarModo = objeto => {
    return {
        type: 'cambiarModo',
        payload: objeto
    }
}

module.exports = {
    cambiarModo
}